<template>
  <div v-if="value"
       class="iframe-overlay"
       @click.stop="closeDialog($event)">
    <v-dialog :value="value"
              content-class="iframe-dialog"
              width="800"
              :persistent="true"
              :scrollable="false"
              :hide-overlay="true">
      <button class="closeBtn"
              @click.prevent="closeDialog($event)">
        <app-svg-icon class="closeIcon"
                      name="ic_close_black" />
      </button>
      <iframe :src="iframeSrc"></iframe>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    iframeSrc: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeDialog(e) {
      this.$emit('close', e);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.iframe-overlay {
  position: fixed;
  z-index: 199;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: $overlay-color;
}

.iframe-dialog {
  height: 700px;
  overflow: hidden;
  position: relative;

  .closeBtn {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 16px;
    height: 16px;
    border: none;
    outline: none;

    .closeIcon {
      width: 16px;
      height: 16px;
    }
  }

  iframe {
    margin-top: 20px;
    height: calc(100% - 20px);
  }


}
</style>
